// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    PayorAccountMedicalBenefitModelResponse,
    PayorAccountMedicalBenefitModels,
    PayorAccountPharmacyBenefitModelResponse,
    PayorAccountPharmacyBenefitModels,
    PayorLongResponse,
    PayorModelResponse,
    PayorPlanListRequestModel,
    PayorPlanModels,
    PayorResponseModel,
    PayorRoleTypeModels,
    PayorSaveModel,
    PayorSearchModel,
    PayorSearchModelResponse,
    UpsearchModelPayorPayorUpsearchModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class PayorV4Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Get Medical Benefits by Account identifier.
     * @param accountId Account identifier
     */
    public async accountMedicalGet1 (accountId: number): Promise<AxiosResponse<PayorAccountMedicalBenefitModels>> {
        const _url_ = '/payor/v4/AccountMedical/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountMedicalGet1.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayorAccountMedicalBenefitModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorAccountMedicalBenefitModels");
        }
        return response;
    }
    /**
     * 
     * @summary Get Medical Benefits by Account and Payor identifiers.
     * @param accountId Account identifier
     * @param payorId Payor identifier
     */
    public async accountMedicalGet2 (accountId: number, payorId: number): Promise<AxiosResponse<PayorAccountMedicalBenefitModelResponse>> {
        const _url_ = '/payor/v4/AccountMedical/{accountId}/{payorId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
            .replace('{' + 'payorId' + '}', encodeURIComponent(String(payorId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountMedicalGet2.');
        }

        // verify required parameter 'payorId' is not null or undefined
        if (payorId === null || payorId === undefined) {
            throw new Error('Required parameter payorId was null or undefined when calling accountMedicalGet2.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayorAccountMedicalBenefitModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorAccountMedicalBenefitModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get existing Pharmacy Benefits by Account identifier.
     * @param accountId Account identifier
     */
    public async accountPharmacyGet1 (accountId: number): Promise<AxiosResponse<PayorAccountPharmacyBenefitModels>> {
        const _url_ = '/payor/v4/AccountPharmacy/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountPharmacyGet1.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayorAccountPharmacyBenefitModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorAccountPharmacyBenefitModels");
        }
        return response;
    }
    /**
     * 
     * @summary Get an existing Pharmacy Benefit by Account and Payor identifiers.
     * @param accountId Account identifier
     * @param payorId Payor identifier
     */
    public async accountPharmacyGet2 (accountId: number, payorId: number): Promise<AxiosResponse<PayorAccountPharmacyBenefitModelResponse>> {
        const _url_ = '/payor/v4/AccountPharmacy/{accountId}/{payorId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
            .replace('{' + 'payorId' + '}', encodeURIComponent(String(payorId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountPharmacyGet2.');
        }

        // verify required parameter 'payorId' is not null or undefined
        if (payorId === null || payorId === undefined) {
            throw new Error('Required parameter payorId was null or undefined when calling accountPharmacyGet2.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayorAccountPharmacyBenefitModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorAccountPharmacyBenefitModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Create a new Payor.
     * @param payorSaveModel Model containing the details to save
     */
    public async payorCreateByTenantId (payorSaveModel: PayorSaveModel): Promise<AxiosResponse<PayorLongResponse>> {
        const _url_ = '/payor/v4/Payor';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'payorSaveModel' is not null or undefined
        if (payorSaveModel === null || payorSaveModel === undefined) {
            throw new Error('Required parameter payorSaveModel was null or undefined when calling payorCreateByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(payorSaveModel, "PayorSaveModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayorLongResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorLongResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get an existing Payor by Tenant and Payor identifiers
     * @param payorId Payor identifier
     */
    public async payorGetByTenantId (payorId: number): Promise<AxiosResponse<PayorModelResponse>> {
        const _url_ = '/payor/v4/Payor/{payorId}'
            .replace('{' + 'payorId' + '}', encodeURIComponent(String(payorId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'payorId' is not null or undefined
        if (payorId === null || payorId === undefined) {
            throw new Error('Required parameter payorId was null or undefined when calling payorGetByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayorModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get existing Payor Plans by Tenant identifier and list of Payor identifiers.
     * @param payorPlanListRequestModel PayorPlanListRequestModel object
     */
    public async payorPlanListByTenantId (payorPlanListRequestModel: PayorPlanListRequestModel): Promise<AxiosResponse<PayorPlanModels>> {
        const _url_ = '/payor/v4/PayorPlanList';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'payorPlanListRequestModel' is not null or undefined
        if (payorPlanListRequestModel === null || payorPlanListRequestModel === undefined) {
            throw new Error('Required parameter payorPlanListRequestModel was null or undefined when calling payorPlanListByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(payorPlanListRequestModel, "PayorPlanListRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayorPlanModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorPlanModels");
        }
        return response;
    }
    /**
     * 
     * @summary Search for an existing Payor.
     * @param payorSearchModel PayorSearchModel object
     */
    public async payorSearchByTenantId (payorSearchModel: PayorSearchModel): Promise<AxiosResponse<PayorSearchModelResponse>> {
        const _url_ = '/payor/v4/PayorSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'payorSearchModel' is not null or undefined
        if (payorSearchModel === null || payorSearchModel === undefined) {
            throw new Error('Required parameter payorSearchModel was null or undefined when calling payorSearchByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(payorSearchModel, "PayorSearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayorSearchModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorSearchModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Update an existing Payor.
     * @param payorId Payor identifier
     * @param payorSaveModel Model containing the details to save
     */
    public async payorUpdateByTenantId (payorId: number, payorSaveModel: PayorSaveModel): Promise<AxiosResponse<PayorResponseModel>> {
        const _url_ = '/payor/v4/Payor/{payorId}'
            .replace('{' + 'payorId' + '}', encodeURIComponent(String(payorId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'payorId' is not null or undefined
        if (payorId === null || payorId === undefined) {
            throw new Error('Required parameter payorId was null or undefined when calling payorUpdateByTenantId.');
        }

        // verify required parameter 'payorSaveModel' is not null or undefined
        if (payorSaveModel === null || payorSaveModel === undefined) {
            throw new Error('Required parameter payorSaveModel was null or undefined when calling payorUpdateByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(payorSaveModel, "PayorSaveModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayorResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorResponseModel");
        }
        return response;
    }
    /**
     * 
     * @summary Upsearch Payor
     * @param upsearchModelPayorPayorUpsearchModel PayorUpsearchModel object
     */
    public async payorUpsearchByTenantId (upsearchModelPayorPayorUpsearchModel: UpsearchModelPayorPayorUpsearchModel): Promise<AxiosResponse<PayorLongResponse>> {
        const _url_ = '/payor/v4/PayorUpsearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'upsearchModelPayorPayorUpsearchModel' is not null or undefined
        if (upsearchModelPayorPayorUpsearchModel === null || upsearchModelPayorPayorUpsearchModel === undefined) {
            throw new Error('Required parameter upsearchModelPayorPayorUpsearchModel was null or undefined when calling payorUpsearchByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(upsearchModelPayorPayorUpsearchModel, "UpsearchModelPayorPayorUpsearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayorLongResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorLongResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get Plan Types
     */
    public async planTypeGet (): Promise<AxiosResponse<PayorRoleTypeModels>> {
        const _url_ = '/payor/v4/PlanType';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayorRoleTypeModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorRoleTypeModels");
        }
        return response;
    }
}
